import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
	FlipCard,
	AudioButton,
	Box,
	VocabularyCard,
	ExampleCard,
	Overlay,
	LessonHeader,
	TipsContent,
} from 'components';
import { useLessonState } from 'providers/LessonProvider';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useBooksResource } from 'utils';
import { PageName } from 'routes/constants';
import { UiVocabularyPage,UiVocabularyPageFlip } from './VocabularyPage.style';
import { useHistory } from 'react-router-dom';

import clickTips from 'assets/images/clickTips.svg';
import { checkNaniOneClass } from "../../utils/hooks/login";

/**
 * 單字、單字例句 頁面
 */
const LocalStorageKey = 'isFirstTimeInVocabularyPage';

export const VocabularyPage = ({ name }) => {
	const history = useHistory();
	const pageTitle = name === PageName.Vocabulary ? '單字學習' : '單字例句';
	const defaultSide = name === PageName.Vocabulary ? FlipCard.Side.Front : FlipCard.Side.Back;
	const { getAudioSource, lessonHeader } = useBooksResource();
	const state = useLessonState();
	const vocabulary = state.context.vocabulary.contents || [];
	const [currentIndex, setCurrentIndex] = useState(0);
	const { overlayIsActive, closeOverlay } = Overlay.useOverlay(
		localStorage.getItem(LocalStorageKey) === 'false' ? false : true,
	);

	useEffect(() => {
		checkNaniOneClass((res) => {
			if (!res) {
				history.push(`/`);
				return;
			}
		})
	})

	const slideChangeHandler = (event) => {
		setCurrentIndex(event.realIndex);
	};

	const overlayClickHandler = () => {
		localStorage.setItem(LocalStorageKey, false);
		closeOverlay();
	};

	const audioSource = getAudioSource(vocabulary[currentIndex]?.wordSound);

	return (
		<UiVocabularyPage>
			<Overlay onClick={overlayClickHandler} isActive={overlayIsActive}>
				<Box height="100%" display="flex" justifyContent="center" alignItems="center">
					<TipsContent
						imgSrc={clickTips}
						content={
							<p>
								點擊卡片翻轉單字卡
								<br />
								讓背單字更加容易！
							</p>
						}
					/>
				</Box>
			</Overlay>
			<LessonHeader title={lessonHeader} variant="inverse" />
			<div className="pageTitle">{pageTitle}</div>
			<UiVocabularyPageFlip>
				{
					vocabulary.map((item,index) => (
						<FlipCard
								key={item.word}
								defaultSide={defaultSide}
								front={<VocabularyCard KK={item.KK} word={item.word} partOfSpeech={item.partOfSpeech} />}
								back={<ExampleCard data={item}/>}
								src={vocabulary[index]?.wordSound}
							/>
					))
				}
			</UiVocabularyPageFlip>
			{/* {vocabularyTemp && <Swiper
				onSlideChange={slideChangeHandler}
				slidesPerView={'auto'}
				loopedSlides={2}
				loop={false}
				centeredSlides={true}
				spaceBetween={10}>
				{vocabulary.map((item) => (
					<SwiperSlide key={item.word}>
						{({ isActive }) => (
							<FlipCard
								defaultSide={defaultSide}
								front={<VocabularyCard KK={item.KK} word={item.word} partOfSpeech={item.partOfSpeech} />}
								back={<ExampleCard data={item} isActive={isActive} />}
							/>
						)}
					</SwiperSlide>
				))}
			</Swiper>} */}
			
		</UiVocabularyPage>
	);
};

VocabularyPage.propTypes = {
	name: PropTypes.string,
};
